import { useState, useRef, useEffect } from 'react';
import store from 'src/state.js';
import EmployeePicker from 'src/RnRCommonComponent/EmployeePicker/index.js';
import { gql } from 'graphql-tag'
import dayjs from 'dayjs';
import { Button, Input, message, Modal, Spin, Tooltip, Typography, Table, Form } from 'antd';
import {
	CloseOutlined,
	CloseCircleFilled,
	CheckCircleOutlined,
	CloseCircleOutlined,
} from '@ant-design/icons';
import { fetchModernFormQuestions } from 'src/_shared/services/utils';
import { getColumnSearchProps } from './filterSearch.jsx';
import './ApprovalBonusList.scss';
import NoDataState from '../../RnRCommonComponent/noDataState/NoDataState.jsx';
import { addCommas } from '../../rewardsAndRecognitionHelper/utils.js';
import SendRewardContainer from 'src/home/container/sendRewardContainer/SendRewardContainer.jsx';
import FormPreview from 'src/new-form-builder/FormPreview.jsx';
import { ReactComponent as RewardIcon } from 'src/assets/svg/rewardOne.svg';
import { ReactComponent as RecipientIcon } from 'src/assets/svg/recipientOne.svg';
import 'src/home/presentation/dashboardPresentation/style.scss';
import { withApollo } from 'react-apollo';

const ApprovalBonusListPresentation = ({
	approvalBonus,
	isLoading,
	approvalCount,
	client,
}) => {
	const searchInput = useRef(null);
	const [sendrewardObject, setSendRewardObject] = useState({});
	const [isShoutOutSend, setIsShoutOutSend] = useState(false);
	const [isOpenRewardModel, setIsOpenRewardModel] = useState(false);
	const [isEmployeeSelected, setIsEmployeeSelected] = useState(false);
	const [isEmployeeNameVisible, setIsEmployeeNameVisible] = useState(false);
	const [isHovered, setIsHovered] = useState(null);
	const [currentStep, setCurrentStep] = useState(0);
	const { Text } = Typography;
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const [searchedEmployeeData, setSearchedEmployeeData] = useState([]);
	const [confirmModalVisible, setConfirmModalVisible] = useState(false);
	const [currentAssignment, setCurrentAssignment] = useState(null);
	const [actionType, setActionType] = useState(null); // 'approve' or 'decline'
	const state = store.getState();
	const currentUser = state.user.currentUser;
	const { company, ...currentUserForPreview } = currentUser;
	const allMultiLingualDataForPreview = state.dashboard?.allMultiLingualData;
	const gifIds = company?.gifIds;

	const [currentJustificationFormDefinition, setCurrentJustificationFormDefinition] = useState(null);
	const [justificationFormInstance] = Form.useForm();
	const [customFormQuestions, setCustomFormQuestions] = useState({});
	const [snappyRewardGrant, setSnappyRewardGrant] = useState({});

	const defaultForm = {
		elements: [
			{
				type: "textarea",
				name: "situation_description",
				label: "Describe reason for Recognition",
				placeholder: "Enter response",
				required: true,
				id: "5a162fd4-4dff-4c73-a0c8-81f2aec9e302"
			}
		],
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			const inputElement = document.querySelector('.gpr-search');
			if (inputElement) {
				inputElement.placeholder = 'Search GIFs';
				clearInterval(intervalId);
			}
		}, 100);

		return () => clearInterval(intervalId);
	}, []);

	useEffect(() => {
		const tryFetchingCustom = async () => {
			const customForm = await fetchModernFormQuestions(
				currentUser,
				'custom',
				'manager_justification_form'
			);
			if (customForm) {
				setCustomFormQuestions(customForm);
				setCurrentJustificationFormDefinition(customForm || defaultForm);
			}
		};
		tryFetchingCustom();
	}, []);

	const handleMouseOver = (elementType) => {
		setIsHovered(elementType);
	};

	const handleMouseLeave = () => {
		setIsHovered('');
	};

	const handleSetSelectedEmployee = (value) => {
		setSelectedEmployee(value);
		setSendRewardObject({
			...sendrewardObject,
			employeeDetail: value,
		});
		setIsEmployeeSelected(false);
		setIsEmployeeNameVisible(true);
		setIsHovered(false);
	};

	const matchedEmployee = searchedEmployeeData.find(
		(e) => e.id === sendrewardObject?.employeeDetail
	);
	const createBadgeAssignment = `mutation CreateBadgeAssignment($input: CreateBadgeAssignmentInput!) {
	 createBadgeAssignment(input: $input) {
	   badgeId
	   userId
	   awardedBy
	   companyId
	   createdAt
	   updatedAt
	   approvalStatus
	   points
	   user {
	     id
	     firstName
	     lastName
	   }
	   badge {
	     id
	     name
	     description
	     points
	   }
	 }
}`;

const updateBadgeAssignment = `mutation UpdateBadgeAssignment($input: UpdateBadgeAssignmentInput!) {
	 updateBadgeAssignment(input: $input) {
	   id
	   badgeId
	   userId
	   awardedBy
	   companyId
	   createdAt
	   updatedAt
	   approvalStatus
	 }
}`;

	const sendBadgeAssignement = async ({justificationData = {}, sendObject = {}}) => {
		const badgeAssignmentPayload = {
			itemType: 'BadgeAssignment',
			badgeId: sendObject.selectedBadge.id,
			companyId: company.id,
			userId: sendObject?.employeeDetail,
			awardedBy: currentUser.id,
			justificationFormAnswers: JSON.stringify(justificationData),
			managerAssigned: true,
			content: {
				message: sendObject?.content?.message?.trim(),
				gifURL: sendObject?.content?.gifURL,
			},
		};
		setIsShoutOutSend(true);
		try {
			const { data, error } = await client.mutate({
				mutation: gql(createBadgeAssignment),
				variables: { input: badgeAssignmentPayload },
			});
			if (data?.createBadgeAssignment) {
				console.log(data.createBadgeAssignment);
			} else {
				throw error;
			}
			message.success("Recognition Sent Successfully");
			
			setSendRewardObject({});
			setSelectedEmployee(null);
			setIsEmployeeNameVisible(false);
			setCurrentJustificationFormDefinition(null);
		} catch (error) {
			message.error("Something went wrong trying to send Recognition");
			console.log(error);
		}
		setIsShoutOutSend(false);
		justificationFormInstance.resetFields();
	};

	const handleSendShoutout = async () => {
		if (
			sendrewardObject?.employeeDetail === undefined ||
			sendrewardObject?.employeeDetail === null
		) {
			setIsEmployeeSelected(true);
			return;
		}
		if (
			(!sendrewardObject?.content ||
				sendrewardObject?.content?.message?.trim().length === 0) &&
			!sendrewardObject?.rewardtype
		) {
			message.error('Please add recognition or message to assign.');
			return;
		}
		setCurrentJustificationFormDefinition(customFormQuestions || defaultForm);
	};

	const onJustificationFormInternalFinish = async (values) => {
		const justificationRequired = (company?.recognitionSettings?.requireAdminApproval
			|| !sendrewardObject?.selectedBadge?.isPreApproved)
			&& company?.recognitionSettings?.requireJustification;
		
		const justificationData = justificationRequired ? {...values} : {};
		await sendBadgeAssignement({justificationData, sendObject: {...sendrewardObject}});
		
		setCurrentStep(0);
		justificationFormInstance.resetFields();
		setSendRewardObject({});
		setSelectedEmployee(null);
		setIsEmployeeNameVisible(false);
		setCurrentJustificationFormDefinition(customFormQuestions || defaultForm);
	};
	
	const onFinishFailed = (error) => {
		console.log("submit failed", error);
	};

	const handleApprove = (assignment) => {
		setCurrentAssignment(assignment);
		setActionType('approve');

		const userData = assignment.userData;
		const bonus = assignment.bonus;
		const currentBudget = userData?.recognitionEvents?.currentBudget || 0;
		
		if (bonus > 0 && bonus > currentBudget) {

			setConfirmModalVisible(true);
		} else {
			updateAssignmentStatus(assignment.id, 'Approved');
		}
	};
	const handleDecline = (assignment) => {
		setCurrentAssignment(assignment);
		setActionType('decline');
		updateAssignmentStatus(assignment.id, 'Declined');
	};

	const updateAssignmentStatus = async (assignmentId, status) => {
		try {
			const { data, error } = await client.mutate({
				mutation: gql(updateBadgeAssignment),
				variables: {
					input: {
						id: assignmentId,
						approvalStatus: status
					}
				}
			});
			
			if (error) {
				throw error;
			}
			
			if (data?.updateBadgeAssignment) {
				message.success(`Recognition ${status === 'Approved' ? 'approved' : 'declined'} successfully`);
			}
		} catch (error) {
			console.error(`Error ${status === 'Approved' ? 'approving' : 'declining'} recognition:`, error);
			message.error(`Failed to ${status === 'Approved' ? 'approve' : 'decline'} recognition`);
		} finally {
			setConfirmModalVisible(false);
			setCurrentAssignment(null);
			setActionType(null);
		}
	};
	
	const handleOverrideApproval = () => {
		if (currentAssignment) {
			updateAssignmentStatus(currentAssignment.id, 'Approved');
		}
	};

	const SummaryStatBox = ({ color = '', statName, label, total, title }) => (
		<div
			className="color-card"
			style={{ width: '33.33333%', background: `var(${color})` }}
		>
			<h4>
				{' '}
				{title === ' Bonuses' && `$`} {addCommas(total)}
			</h4>
			<p>
				{label
					? label
					: statName === 'Total Rewards'
						? 'Total'
						: statName}
			</p>
		</div>
	);

	const statusContent = {
		Approved: 'Approved',
		Declined: 'Not Approved',
		Pending: 'Pending Approval',
		null: 'Pending Approval',
	};

	const statusTextFormatter = (status) => {
		return (
			<span
				style={{
					fontWeight: 'bolder',
					color:
						status === 'Approved'
							? 'green'
							: status === 'Declined'
								? 'red'
								: '#F8AE63',
				}}
			>
				{statusContent[status]}
			</span>
		);
	};

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
	};

	const handleReset = (clearFilters) => {
		clearFilters();
	};

	const columns = [
		{
			title: 'RECIPIENT',
			dataIndex: 'recipient',
			key: 'recipient',
			...getColumnSearchProps(
				'recipient',
				searchInput,
				handleSearch,
				handleReset,
				'Recipient'
			),
		},
		{
			title: 'RECOGNITION',
			dataIndex: 'reward',
			key: 'reward',
			render: (text, record) => (
				<span>
					{record.badgeData?.name || text}
				</span>
			),
		},
		{
			title: 'TOTAL COST',
			dataIndex: 'bonus',
			key: 'bonus',
			render: (bonus) => (
				<span style={{ color: bonus === 0 ? 'inherit' : 'green' }}>
					{bonus === 0 ? 'None' : '$' + addCommas(bonus)}
				</span>
			),
		},
		{
			title: 'CREATED',
			dataIndex: 'created',
			key: 'created',
			sorter: (a, b) => new Date(a.created) - new Date(b.created),
			render: (record) => dayjs(record).format('MM/DD/YYYY'),
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'status',
			render: (status, record) => {
				if (status === 'Pending') {
					return (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<span style={{ marginRight: 16, color: '#F8AE63', fontWeight: 'bold' }}>
								{statusContent[status]}
							</span>
							{currentUser?.role === 'manager' ? null : (<>
							<Tooltip title="Approve">
								<Button
									type="primary"
									size="small"
									icon={<CheckCircleOutlined />}
									style={{ marginRight: 8, backgroundColor: '#52c41a', borderColor: '#52c41a' }}
									onClick={() => handleApprove(record)}
								/>
							</Tooltip>
							<Tooltip title="Decline">
								<Button
									type="primary"
									danger
									size="small"
									icon={<CloseCircleOutlined />}
									onClick={() => handleDecline(record)}
								/>
							</Tooltip>
							</>)}
						</div>
					);
				}
				return statusTextFormatter(status);
			},
		},
		{
			title: 'DECLINE REASON',
			dataIndex: 'declineReason',
			key: 'declineReason',
			render: (declineReason) =>
				declineReason ? (
					<Tooltip placement="top" title={declineReason}>
						<i
							className="icon-message-outline"
							alt=""
							style={{ color: 'var(--silver-chalice)', fontSize: 18 }}
						/>
					</Tooltip>
				) : null,
		},
	];

	return (
		<div>
			<div className="d-flex" style={{ gap: '20px', marginBottom: '20px' }}>
				<div className="d-flex flex-column" style={{ flex: '1' }}>
					<div className="d-card height-equal mb-3">
						<div className="d-card-head">
							<h4 className="dashboard-title">SEND RECOGNITION</h4>
						</div>
						
						{/* Step content */}
						<div className="steps-content" style={{
							//overflowY: 'auto',
							marginBottom: '16px',
							padding: '20px',
							backgroundColor: '#fafafa',
							border: '1px dashed #e9e9e9',
							borderRadius: '2px'
						}}>
							{(
								<>
									{/* Step 1 Content: Employee & Badge Selection */}
									<div className="pb-2 w-100 send-modal-btn">
										<div className="send-modal-container">
											<div style={{ height: '34px' }}>
												{isEmployeeNameVisible &&
												sendrewardObject &&
												sendrewardObject?.employeeData !== null &&
												sendrewardObject?.employeeDetail !== undefined ? (
													<div
														className="dropdown-wrapper"
														onMouseOver={() => handleMouseOver('recipient')}
														onMouseLeave={handleMouseLeave}
														onClick={() => {
															setSelectedEmployee(null);
															setIsEmployeeNameVisible(false);
															setSendRewardObject({
																...sendrewardObject,
																employeeDetail: null,
															});
														}}
														style={
															isHovered === 'recipient' ? { cursor: 'pointer' } : {}
														}
													>
														<div className="badge-box">
															<div className="dropdown-container">
																<div
																	className={`dropdown-content ${isHovered === 'recipient' ? 'hidden' : ''}`}
																>
																	<RecipientIcon className="at-symbol-icon-filled" />
																	<div className="dropdown-text">
																		<Text
																			style={{ maxWidth: 120, color: '#fff' }}
																			ellipsis={true}
																		>
																			{(
																				matchedEmployee?.firstName +
																				' ' +
																				matchedEmployee?.lastName
																			)?.trim()}
																		</Text>
																	</div>
																</div>
																<div
																	className={`dropdown-content hover-content ${isHovered === 'recipient' ? 'visible' : ''}`}
																>
																	<CloseCircleFilled
																		style={{
																			fontSize: '18px',
																			paddingRight: '0px',
																		}}
																	/>
																	<span className="remove-text">
																		<Text
																			style={{ maxWidth: 120, color: '#fff' }}
																			ellipsis={true}
																		>
																			Remove
																		</Text>
																	</span>
																</div>
															</div>
														</div>
													</div>
												) : (
													<EmployeePicker
														selectedEmployee={selectedEmployee}
														setSelectedEmployee={handleSetSelectedEmployee}
														setSearchedEmployeeData={setSearchedEmployeeData}
														placeholder={
															<div style={{ height: 34, width: 120 }}>
																<RecipientIcon
																	style={{
																		height: 18,
																		width: 18,
																		marginRight: '4px',
																	}}
																/>
																<span style={{ verticalAlign: 'middle' }}>
																	Select Recipient
																</span>
															</div>
														}
													/>
												)}
												{isEmployeeSelected ? (
													<div className="ant-form-explain text-danger mt-1">
														Please add employee
													</div>
												) : (
													<></>
												)}
											</div>
											
											{/* Badge selection */}
											{sendrewardObject?.selectedBadge ? (
												<div
													onMouseOver={() => handleMouseOver('reward')}
													onMouseLeave={handleMouseLeave}
													onClick={() => {
														setSendRewardObject({
															...sendrewardObject,
															selectedBadge: null,
															rewardtype: null,
														});
													}}
													style={
														isHovered === 'reward' ? { cursor: 'pointer' } : {}
													}
												>
													<div className="d-flex align-items-center badge-box">
														<div className="feed-reward-logo">
															<RewardIcon style={{ height: 18, width: 18 }} />
														</div>
														<div className="d-flex align-items-center text-box">
															<span className="selected-badge-name">
																{sendrewardObject?.selectedBadge?.name}{' '}
															</span>
															<CloseOutlined
																onClick={() => {
																	setSendRewardObject({
																		...sendrewardObject,
																		selectedBadge: null,
																		rewardtype: null,
																	});
																}}
															/>
														</div>
													</div>
												</div>
											) : (
												<div>
													<Button
														shape="round"
														className={
															'd-flex justify-content-start add-reward-btn' +
															(!Boolean(selectedEmployee)
																? ' reward-unselected'
																: ' reward-selected')
														}
														disabled={!Boolean(selectedEmployee)}
														onClick={() => {
															setIsOpenRewardModel(true);
														}}
													>
														<RewardIcon style={{ height: 18, width: 18 }} />
														<span style={{ marginLeft: 0 }}>Give Recognition</span>
													</Button>
												</div>
											)}
										</div>
									</div>

									{/* Content: Justification Form */}
									{currentJustificationFormDefinition && (
										<FormPreview
											elements={currentJustificationFormDefinition.elements}
											formMetadata={currentJustificationFormDefinition.metadata}
											formType="custom"
											isPreview={false}
											onFinsh={onJustificationFormInternalFinish}
											onFinshFailed={onFinishFailed}
											formFromProps={justificationFormInstance}
											customButton={"Submit Answers"}
											cancelFunction={() => setCurrentStep(0)}
											currentUser={currentUserForPreview}
											allMultiLingualData={allMultiLingualDataForPreview}
											disabled={!selectedEmployee || !sendrewardObject?.selectedBadge}
										/>
									)}
								</>
							)}
						</div>
					</div>
				</div>

				<div className="d-flex flex-column" style={{ flex: '1' }}>
					<div className="contact-card" style={{ backgroundColor: 'white', padding: '10px 16px', border: '1px solid #E5E5E5', borderRadius: '10px' }}>
						<div className="contact-card-inner">
						<div className="contact-card-title">
							<p style={{ fontSize: '14px', fontWeight: '800', color: 'var(--dove-gray)' }}>Recognition Approval Status</p>
						</div>
							
							<div className="contact-color-card">
								{approvalCount?.approvalStatusCounts.length > 0 &&
									approvalCount?.approvalStatusCounts.map(
										(reward, index) => (
											<SummaryStatBox
												key={reward.id || index}
												color={reward.color}
												statName={reward.name}
												total={reward.totals}
											/>
										)
									)}
							</div>
						</div>
					</div>
					<div className="contact-card mt-3" style={{ backgroundColor: 'white', padding: '10px 16px', border: '1px solid #E5E5E5', borderRadius: '10px' }}>
						<div className="contact-card-inner">
							<div className="contact-card-title">
								<p style={{ fontSize: '14px', fontWeight: '800', color: 'var(--dove-gray)' }}>Bonuses</p>
							</div>
							<div className="contact-color-card">
								{approvalCount?.rewardPointsValues.length > 0 &&
									approvalCount?.rewardPointsValues.map(
										(reward, index) => (
											<SummaryStatBox
												key={reward.id || index}
												color={reward.color}
												statName={reward.name}
												total={`$${reward.totals}`}
											/>
										)
									)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Full-width section for the table */}
			<div className="page-title mt-3">
				<h2 className="page-heading">Approval Status</h2>
			</div>
			<div className="table-card">
				<Table
					columns={columns}
					dataSource={approvalBonus.map((item, index) => ({
						...item,
						key: item.id || index,
					}))}
					isLoading={isLoading}
					pagination={{ pageSize: 10, showSizeChanger: false }}
					locale={{
						emptyText: (
							<NoDataState title="No recognitions available." />
						),
					}}
				/>
			</div>
			
			{/* Modal for rewards */}
			<Modal
				width={560}
				className=""
				open={isOpenRewardModel}
				title="Give Recognition"
				footer={false}
				onOk={false}
				onCancel={() => {
					setSendRewardObject({
						...sendrewardObject,
						rewardtype: null,
						selectedBadge: null,
					});
					setIsOpenRewardModel(false);
				}}
				destroyOnClose={true}
			>
				<SendRewardContainer
					isLoading={isLoading}
					setIsOpenRewardModel={setIsOpenRewardModel}
					sendrewardObject={sendrewardObject}
					setSendRewardObject={setSendRewardObject}
					recipientId={sendrewardObject?.employeeDetail}
					handleSendShoutout={handleSendShoutout}
				/>
			</Modal>
			
			{/* Confirmation Modal for Budget Override */}
			<Modal
				title="Budget Warning"
				open={confirmModalVisible}
				onCancel={() => setConfirmModalVisible(false)}
				footer={[
					<Button key="cancel" onClick={() => setConfirmModalVisible(false)}>
						Cancel
					</Button>,
					<Button
						key="noBonus"
						type="default"
						onClick={() => {
							// Approve without bonus
							if (currentAssignment) {
								// Set bonus to 0 and approve
								const assignmentId = currentAssignment.id;
								updateAssignmentStatus(assignmentId, 'Approved');
							}
						}}
					>
						Approve Without Bonus
					</Button>,
					<Button
						key="override"
						type="primary"
						danger
						onClick={handleOverrideApproval}
					>
						Override Budget
					</Button>,
				]}
			>
				<p>
					The recipient does not have enough budget for this recognition bonus.
					<br />
					Current budget: ${currentAssignment?.userData?.recognitionEvents?.currentBudget || 0}
					<br />
					Required: ${currentAssignment?.bonus || 0}
				</p>
				<p>Would you like to approve without a bonus or override the budget?</p>
			</Modal>
		</div>
	);
};

export default withApollo(ApprovalBonusListPresentation);
